import React from 'react';

import { AppSpinner } from 'src/components/ApartmentPageV2/AppSpinner';
import { useHouseSpinner } from 'src/components/FilterProperty/components/FilterDesktop/hooks';
import { floorsAdditionalSpinnerId } from 'src/constants';
import { ISpinnerFitType } from 'src/typings/spinner';
import { useGetFilterParams } from 'src/hooks';
import { ListOfKeysFilterAllData } from 'src/typings/filter';
import { useGetSelectedApartment } from './useGetSelectedApartment';
import { useStyles } from './styles';

export const ComponentHouseSpinner: React.FC = () => {
  const { selectedApartmentId } = useGetSelectedApartment();
  const { selectedParams } = useGetFilterParams();
  const {
    filteredIds, spinnerData, combineFilterIds, type,
  } = useHouseSpinner();
  const styles = useStyles({});

  const currentListApartment = (): string[] => {
    const houseFilters = selectedParams.filter((param) => param.name !== ListOfKeysFilterAllData.placementHouse);
    if (selectedApartmentId?.length) return [selectedApartmentId];
    if (filteredIds?.placement?.length && houseFilters.length) return filteredIds?.placement;

    return combineFilterIds;
  };

  if (!spinnerData) return null;

  return (
    <div id={floorsAdditionalSpinnerId} className={styles.wrapperFloorsHouseSpinner}>
      <AppSpinner
        type={type}
        hideWindRose
        customDisplayIds={currentListApartment()}
        objectFit={ISpinnerFitType.contain}
        spinnerData={spinnerData}
        hideControls
      />
    </div>
  );
};
